<template>
  <div style="height: 100%">
    <portal to="v-dir-title">
      <v-btn class="mx-1" @click="isAnalysis = !isAnalysis">
        <v-icon left class="mx-0"> {{ isAnalysis ? "mdi-checkbox-outline" : "mdi-checkbox-blank-outline" }} </v-icon>
        <v-icon right> fas fa-search-dollar </v-icon>
      </v-btn>
      <v-btn-toggle v-if="isAnalysis" v-model="period" mandatory borderless dense @change="onChangePeriod" class="ml-1">
        <v-btn value="3M">
          <span class1="hidden-md-and-down">3 мес</span>
        </v-btn>
        <v-btn value="6M" class="mx-1">
          <span class1="hidden-md-and-down">6 мес</span>
        </v-btn>
        <v-btn value="1Y" @click="showConfig = true">
          <span class1="hidden-md-and-down">1 год</span>
        </v-btn>
      </v-btn-toggle>
    </portal>
    <a-table-f-api v-if="!isAnalysis" ref="table" :api="dirCurrent.api" :model="model" :useQuery="false" :defaults="defaults" @click="onClickRow($event)" />
    <a-table-f-api-post
      v-else-if="dateStart"
      ref="table"
      :apiPost="{ api: '/report_sql/filters', params: paramsApi }"
      :model="model"
      :useQuery="false"
      :selectedRows="selectedRows"
      :defaults="defaults" 
      @click="onClickRow($event)"
    />
    <AvgPrice v-if="showEditDialog" v-model="showEditDialog" :id="idEdit" :api="dirCurrent.api" :dir="dirCurrent" />
    <popup-window v-if="infoSnack" :type="3" :data="infoData" :model="infoModel" />
  </div>
</template>

<script>
import { getAccess, genModel, keyDetect, doubleClickDetect } from "@/components/mixings";

export default {
  mixins: [getAccess, genModel, keyDetect, doubleClickDetect],
  props: {
    dirCurrent: Object,
  },
  components: {
    AvgPrice: () => import("./../dialogs/goodsTypeAvgPrice"),
  },
  data() {
    return {
      isAnalysis: false,
      idEdit: 0,
      idItemShow: 0,
      showEditDialog: false,
      m: this.$store.getters["config/get"].models.dirs,
      url: "",
      type: null,
      infoData: null,
      infoModel: null,
      dateStart: null,
      dateEnd: null,
      period: "3M",
    };
  },
  created() {
    this.onChangePeriod();
  },
  computed: {
    title() {
      let t = this.dirM.title + ` с ${this.dateStart} по ${this.dateEnd}`;
      this.$root.title = t;
      return t;
    },
    paramsApi() {
      return {
        name: "goods_getEveragePrice",
        params: {
          date_start: this.dateStart,
          date_end: this.dateEnd,
        },
      };
    },
    defaults() {
      return { sort: { key: "id", order: "ASC" }, filters: this.dirCurrent.filters, paramName: this.dirCurrent.name };
    },
    dirM() {
      const name = this.dirCurrent?.name || null;
      let m;
      if (this.dirCurrent?.model && typeof this.dirCurrent?.model == "string" && this.$store.getters["config/get"].models?.[this.dirCurrent.model]) {
        m = Object.assign({}, this.$store.getters["config/get"].models[this.dirCurrent.model]);
      } else {
        m = Object.assign({}, this.m[name]);
      }
      return m;
    },

    infoSnack() {
      if (this.keysModified) {
      }
      let res = this.keys?.ctrl && this.isAnalysis;
      this.infoData = null;
      this.infoModel = null;
      if (res) this.showPriceDetail();
      return res;
    },
    model() {
      const name = this.dirCurrent?.name || null;

      if (!name) return {};
      let model;
      let m;
      if (this.dirCurrent?.model && typeof this.dirCurrent?.model == "string" && this.$store.getters["config/get"].models?.[this.dirCurrent.model]) {
        m = Object.assign({}, this.$store.getters["config/get"].models[this.dirCurrent.model]);
      } else {
        m = Object.assign({}, this.m[name]);
      }
      model = !this.isAnalysis
        ? m.list
        : [
            { name: "id", title: "id", type: "number", sortable: true, width: 30 },
            { name: "name", title: "Название", type: "string", sortable: true, width: 300 },
            { name: "category_id", title: "Категория", type: "select", dir: "category", dirFilter: { type: 2 }, sortable: true, width: 200 },
            { name: "price_comfort", title: "Цена (комфорт)", type: "number", sortable: true, width: 80 },
            { name: "price_business", title: "Цена (бизнес)", type: "number", sortable: true, width: 80 },
            { name: "price_premium", title: "Цена (премиум)", type: "number", sortable: true, width: 80 },
            { name: "max_price_real", title: "max", type: "number", sortable: true, width: 80 },
            { name: "min_price_real", title: "min", type: "number", sortable: true, width: 80 },
            { name: "avg_price_real", title: "avg", type: "number", sortable: true, width: 80 },
            { name: "status", title: "Статус", type: "select", options: "status_active", default: 1, validator: ["req"] },
            { name: "updatedon", title: "Дата обновления", type: "date", sortable: true, width: 80 },
          ];

      model.forEach((el) => {
        if (el?.sourceList) {
          el.options = m[el.sourceList];
        }
        if (el.name == "price_business") {
          // el.textColor = "user_viewedon";
          el.textColor = (values) => {
            return values.price_business < values.avg_price_real ? "red" : "";
          };
        }
      });

      return model;
    },
  },
  watch: {
    isAnalysis(v) {
      if (v) this.onChangePeriod();
    },
  },
  methods: {
    updateData() {
      this.$refs.table.updateData();
    },
    onDoubleClick(r) {
      if (this.isAnalysis) {
        this.idEdit = r.row.id;
        this.showEditDialog = true;
      }
    },
    onClickRow(d) {
      if (this.isAnalysis) {
        this.counter += 1;
        this.onDetectClick(d);
        return;
      }
      this.$emit("clickRow", d);

      //if (!this.canEdit ) return
      return;
      if (this.dirCurrent.type == "config") {
        this.showEditDialogFun(d.row.id);
      } else if (!this.dirCurrent.type) {
        if (this.dirCurrent.view) this.idItemShow = d.row.id;
        else if (this.dirM.viewName) this.loadComponent(d, this.dirM);
        else this.showEditDialogFun(d.row.id);
      }
    },
    setTitle() {
      // this.$root.title = this.title;
    },
    async onChangePeriod(e) {
      if (!e) e = this.period;
      const ranges = {
        "3M": 90,
        "6M": 180,
        "1Y": 365,
      };

      if (ranges[e]) {
        const start = new Date();
        const end = new Date();
        start.setDate(start.getDate() - ranges[e]);
        this.dateStart = start.date;
        this.dateEnd = end.date;
      }
      if (e == "select") {
        return;
        console.log(res);
        this.paramsApi.params.ds = new Date().date;
        this.paramsApi.params.de = new Date().addDays(30).date;
      }
      this.setTitle();
    },
    async showPriceDetail() {
      let id = this.selectedRows[0];
      if (!id) return;
      let data;
      let model;
      let params = {
        name: "goods_getEveragePrice_detail",
        params: {
          date_start: this.dateStart,
          date_end: this.dateEnd,
          id,
        },
      };
      const d = await this.$axios.post("/report_sql/filters", params);
      if (d.data && d.data.data) {
        let data = d.data.data;
        model = [
          { name: "name", title: "Название", type: "string", sortable: true, width: 300 },
          { name: "amount_real", title: "Кол-во", type: "number", sortable: true, width: 80 },
          { name: "price_real", title: "Цена", type: "number", sortable: true, width: 80 },
        ];
        this.infoData = data;
        this.infoModel = model;
      }
    },
    createNew() {
      this.showEditDialogFun(null);
    },
    showEditDialogFun(id) {
      this.idEdit = id;
      this.showEditDialog = true;
    },
    itemShowClose() {
      this.loading = true;
      this.$root.title = "Справочники";
      this.$refs.table.updateRowData(this.idItemShow);
      this.loading = !true;
      this.idItemShow = 0;
    },
  },
};
</script>
